// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::before,
*::after {
  box-sizing: border-box;
}

.differentiation-table {
  margin-top: 24px;
}
.differentiation-table .filter-wrapper {
  align-items: flex-end;
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
  width: 100%;
}
.differentiation-table .filter-wrapper h5 {
  color: #0669B3;
  font-size: 1.25rem;
  font-weight: 700;
  margin: 0;
}
.differentiation-table .filter-wrapper .roster-table-filter-label {
  color: #0669B3;
  display: flex;
  flex-direction: column;
  font-weight: 600;
  width: 300px;
}
.differentiation-table .filter-wrapper .roster-table-filter-label .roster-table-filter {
  border: 1px solid #808080;
  border-radius: 5px;
  font-size: 14px;
  margin-top: 4px;
  padding: 6px 8px;
}
.differentiation-table .table-wrapper {
  border: 1px solid #D1D3D4;
  border-radius: 5px;
  max-height: 400px;
  overflow-y: auto;
}
.differentiation-table table {
  border-collapse: separate;
  border-spacing: 0;
  margin: 0;
  width: 100%;
}
.differentiation-table table thead {
  position: sticky;
  top: 0;
  z-index: 10;
}
.differentiation-table table thead tr th {
  background-color: #c0def0;
  border: none;
  border-bottom: 1px solid #D1D3D4;
  color: #0A4064;
  font-size: 0.95rem;
  font-weight: 500;
  padding: 12px 8px;
  text-align: left;
}
.differentiation-table table thead tr th:first-child {
  border-top-left-radius: 5px;
}
.differentiation-table table thead tr th:last-child {
  border-top-right-radius: 5px;
}
.differentiation-table table thead tr th .table-header-button {
  background: transparent;
  border: none;
  color: inherit;
  cursor: pointer;
  font: inherit;
  padding: 0;
  text-align: left;
  width: 100%;
}
.differentiation-table table thead tr th .table-header-button .icon-container {
  display: inline-flex;
  flex-direction: column;
  margin-left: 5px;
  vertical-align: middle;
}
.differentiation-table table tbody tr:hover {
  background-color: rgba(192, 222, 240, 0.3);
}
.differentiation-table table tbody tr td {
  border-bottom: 1px solid #D1D3D4;
  padding: 12px 8px;
}
.differentiation-table table tbody tr td .transparent-button {
  background: transparent;
  border: none;
  color: #0A4064;
  cursor: pointer;
  font-size: 1.1rem;
  padding: 4px 8px;
}
.differentiation-table table tbody tr td .transparent-button:hover {
  color: #0669B3;
}
.differentiation-table .action-buttons {
  display: flex;
  justify-content: flex-end;
  margin-top: 24px;
}`, "",{"version":3,"sources":["webpack://./src/styles/global/Colors.scss","webpack://./src/styles/DifferentiationTable.scss"],"names":[],"mappings":"AAAA;;;EAGI,sBAAA;ACCJ;;AAFA;EACI,gBAAA;AAKJ;AAHI;EACI,qBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;AAKR;AAHQ;EACI,cDoBC;ECnBD,kBAAA;EACA,gBAAA;EACA,SAAA;AAKZ;AAFQ;EACI,cDaC;ECZD,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,YAAA;AAIZ;AAFY;EACI,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;AAIhB;AACI;EACI,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;AACR;AAEI;EACI,yBAAA;EACA,iBAAA;EACA,SAAA;EACA,WAAA;AAAR;AAEQ;EACI,gBAAA;EACA,MAAA;EACA,WAAA;AAAZ;AAGgB;EACI,yBD7CR;EC8CQ,YAAA;EACA,gCAAA;EACA,cDlDV;ECmDU,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;AADpB;AAGoB;EACI,2BAAA;AADxB;AAIoB;EACI,4BAAA;AAFxB;AAKoB;EACI,uBAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;EACA,UAAA;EACA,gBAAA;EACA,WAAA;AAHxB;AAKwB;EACI,oBAAA;EACA,sBAAA;EACA,gBAAA;EACA,sBAAA;AAH5B;AAYgB;EACI,0CAAA;AAVpB;AAagB;EACI,gCAAA;EACA,iBAAA;AAXpB;AAaoB;EACI,uBAAA;EACA,YAAA;EACA,cDlGd;ECmGc,eAAA;EACA,iBAAA;EACA,gBAAA;AAXxB;AAawB;EACI,cDhFf;ACqEb;AAmBI;EACI,aAAA;EACA,yBAAA;EACA,gBAAA;AAjBR","sourcesContent":["*,\n*::before,\n*::after {\n    box-sizing: border-box;\n}\n// EPR colors\n// $dashboard-blue: #007bff; this color does not pass Accessibility. Updated version below.\n$dashboard-blue: #0d6efd;\n$dk-blue-toolbar: #19608f;\n$dk-blue: #0A4064;\n$lt-blue: #7DB7CC;\n$pale-blue: #c0def0;\n$information: #00AEEF;\n$information-hover: #02BFFF;\n$DCSD-logo-green: #84ae30;\n$text: #414042;\n$white: #EDEDED;\n$shadow: #525151;\n$red: #CB321A;\n$red-hover: #E2381D;\n$green: #C7CC68;\n\n$highlight: #FDF9D0;\n$important: #FEBF31;\n$lt-important: #FED883;\n$lt-highlight: #FAFAD2;\n$grey0: #EDF0F1;\n$grey1: #D1D3D4;\n$grey2: #A7A9AC;\n$grey3: #808080;\n$grey3a: #707070;\n$grey4: #636161;\n$grey4a: #444343;\n$pearl-blue: #0669B3;\n$pearl-blue-hover: #1786DB;\n$lt-pearl-blue: #63AEDE;\n$lt-pearl-blue-hover: #4589B3;\n\n$timeline-arrow-1: #718355;\n$timeline-arrow-2: #87986a;\n$timeline-arrow-3: #97a97c;\n$timeline-arrow-4: #b5c99a;\n$timeline-arrow-5: #cfe1b9;\n\n$permission-blue: #ADD8E6;\n$permission-green:#90EE90;\n$permission-orange: #FFA07A;\n","@import \"global/Colors\";\n\n.differentiation-table {\n    margin-top: 24px;\n\n    .filter-wrapper {\n        align-items: flex-end;\n        display: flex;\n        justify-content: space-between;\n        margin-bottom: 16px;\n        width: 100%;\n\n        h5 {\n            color: $pearl-blue;\n            font-size: 1.25rem;\n            font-weight: 700;\n            margin: 0;\n        }\n\n        .roster-table-filter-label {\n            color: $pearl-blue;\n            display: flex;\n            flex-direction: column;\n            font-weight: 600;\n            width: 300px;\n\n            .roster-table-filter {\n                border: 1px solid $grey3;\n                border-radius: 5px;\n                font-size: 14px;\n                margin-top: 4px;\n                padding: 6px 8px;\n            }\n        }\n    }\n\n    .table-wrapper {\n        border: 1px solid $grey1;\n        border-radius: 5px;\n        max-height: 400px;\n        overflow-y: auto;\n    }\n\n    table {\n        border-collapse: separate;\n        border-spacing: 0;\n        margin: 0;\n        width: 100%;\n\n        thead {\n            position: sticky;\n            top: 0;\n            z-index: 10;\n\n            tr {\n                th {\n                    background-color: $pale-blue;\n                    border: none;\n                    border-bottom: 1px solid $grey1;\n                    color: $dk-blue;\n                    font-size: 0.95rem;\n                    font-weight: 500;\n                    padding: 12px 8px;\n                    text-align: left;\n\n                    &:first-child {\n                        border-top-left-radius: 5px;\n                    }\n\n                    &:last-child {\n                        border-top-right-radius: 5px;\n                    }\n\n                    .table-header-button {\n                        background: transparent;\n                        border: none;\n                        color: inherit;\n                        cursor: pointer;\n                        font: inherit;\n                        padding: 0;\n                        text-align: left;\n                        width: 100%;\n\n                        .icon-container {\n                            display: inline-flex;\n                            flex-direction: column;\n                            margin-left: 5px;\n                            vertical-align: middle;\n                        }\n                    }\n                }\n            }\n        }\n\n        tbody {\n            tr {\n                &:hover {\n                    background-color: rgba($pale-blue, 0.3);\n                }\n\n                td {\n                    border-bottom: 1px solid $grey1;\n                    padding: 12px 8px;\n\n                    .transparent-button {\n                        background: transparent;\n                        border: none;\n                        color: $dk-blue;\n                        cursor: pointer;\n                        font-size: 1.1rem;\n                        padding: 4px 8px;\n\n                        &:hover {\n                            color: $pearl-blue;\n                        }\n                    }\n                }\n            }\n        }\n    }\n\n    .action-buttons {\n        display: flex;\n        justify-content: flex-end;\n        margin-top: 24px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
